import template from './form.html';
import { FormActions } from 'core/services/form';
import rucI18N from 'i18n/ruc/es.json';
import commonI18N from 'i18n/common/es.json';
import configFile from 'config.json';
import { formatErrorMessage } from 'core/util';

export let ImportarFormComponent = {
  templateUrl: template,
  selector: 'importarRucForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(rucI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  let unsubscribe;

  this.$onDestroy = () => {
    unsubscribe();
  };

  this.$onInit = () => {
    this.uploadOptions = {
      imageOnly: false,
      target: configFile.serverURL + '/adjuntos',
      publicPath: configFile.publicURL
    };
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    this.title = this.translations['Importar RUCs'];
  };


  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    let model = state.form.model;
    return { form: state.form, model };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.ruc.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Proceso de importación creado'] + `<br/><a class="go-in-notify btn btn-info" href="#/procesos-batch/${state.form.created.id}/view">${this.translations['Visualizar el Proceso']}</a>`, {
        position: 'bottom',
        duration: 9000,
        type: 'success',
        sticky: true,
        button: true,
        html: true
      });
      $state.go('home.ruc.list');
    }
  }

  function doSubmit() {
    if (!this.model.file || !this.model.file.length) {
      // mostrar mensaje de required
      return;
    }
    console.log(this.model.file[0]);
    let data = { 
      path: this.model.file[0].path,
      originalName: this.model.file[0].name
    };

    this.save('ruc/importar', data);
  }
}


// WEBPACK FOOTER //
// ./src/components/ruc/importar-form/form.component.js